export class Stack<T> {
  public elems: T[] = [];
  public length: number = 0;

  public constructor(...initial: T[]) {
    for (const el of initial) {
      this.push(el);
    }
  }

  public clear(): void {
    this.length = 0;
    this.elems = [];
  }

  public push(item: T): void {
    this.elems[this.length++] = item;
  }
  public pop(): T | undefined {
    if (this.length === 0) {
      return undefined;
    }
    return this.elems[--this.length];
  }
  public peek(): T | undefined {
    return this.elems[this.length - 1];
  }
  public isEmpty(): boolean {
    return this.length === 0;
  }

  public intoArray(): T[] {
    return this.elems.slice(0, this.length);
  }

  public toJSON(): T[] {
    return this.intoArray();
  }
}
